import { Record } from 'immutable';

const LinkReservationRequestRecord = Record({
  eventReservationId: null,
  eventId: null,
  payViaGp: true
});

export class LinkReservationRequest extends LinkReservationRequestRecord {
  eventReservationId: number;
  eventId: number;
  payViaGp: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/link-reservation-request.ts